import { Menu } from 'primereact/menu';
import { Button } from 'primereact/button';
import { useRef } from 'react';

interface ActionMenuProps {
    rowData: any;
    hasPermission: (pageName: string, featureName?: string) => boolean;
    open: (rowData: any, type: 'change_status_form' | 'status_h' | 'transfer_h' | 'itinerary' | 'update_invoice') => void;
    toggleSection: (id: number, type: 'req') => void;
    hasReq: boolean
}

export const ActionMenu: React.FC<ActionMenuProps> = ({ rowData, hasPermission, open, toggleSection, hasReq }) => {
    const menuRef = useRef<Menu>(null);

    const items = [
        hasPermission("MyLead", "Edit") && {
            label: 'Edit Lead',
            icon: 'pi pi-pencil',
            command: () => open(rowData, 'change_status_form'),
        },
        hasPermission("MyLead", "History") && {
            label: 'Status History',
            icon: 'pi pi-history',
            command: () => open(rowData, 'status_h'),
        },
        hasPermission("MyLead", "Requirement") && {
            label: 'Requirements',
            icon: 'pi pi-book',
            command: () => toggleSection(rowData.id, 'req'),
        },
        hasPermission("MyLead", "Itinerary") && hasReq && {
            label: 'Itinerary',
            icon: 'pi pi-calendar',
            command: () => open(rowData, 'itinerary'),
        },
        hasReq && {
            label: 'Update Invoice',
            icon: 'pi pi-money-bill',
            command: () => open(rowData, 'update_invoice'),
        },
        {
            label: 'Transfer History',
            icon: 'pi pi-history',
            command: () => open(rowData, 'transfer_h'),
        },
    ].filter(Boolean);

    return (
        <div className="actions-dropdown">
            <Menu model={items as any[]} popup ref={menuRef} />
            <Button
                icon="pi pi-ellipsis-v"
                className="p-button-text p-button-sm p-0"
                onClick={(e) => menuRef.current?.toggle(e)}
            />
        </div>
    );
};
